import { Injectable } from '@angular/core';
import { TComponentController } from '@simOn/common/scan';
import { MatterportComponent } from '@simlab/matterport';
import { TagComponent } from '@simlab/simlab-facility-management/sub-features/tag';
import { Observable } from 'rxjs';
import { ComponentControllerBase } from './component-controller-base';

@Injectable()
export class NavvisPoiControllerService extends ComponentControllerBase implements TComponentController {
  override _nodes: Record<string, MatterportComponent | TagComponent> = {};
  public set selectedMode(value: string) {
    this.mode.includes(value) ? this._showAll() : this._hideAll();
  }
  components$: Observable<unknown> = new Observable();
  readonly _mode = ['poi'];
  override get mode() {
    return this._mode;
  }

  override _hideAll(): void {
    this.scanManagerService.poi && this.scanManagerService.poi.setPoiVisibility(false);
  }
  override _showAll(): void {
    this.scanManagerService.poi && this.scanManagerService.poi.setPoiVisibility(true);
  }
}
